module.exports = __webpack_public_path__ + "images/crowdfunder-b92b1f11ac0b5d87f235646b4f256e08.png";